export const templatesIndex = {
  header: {
    title: "Modelli WhatsApp",
    description:
      "Crea e modifica i modelli proprio come in Meta (intestazione/corpo/piè di pagina/pulsanti + anteprima).",
    create: "Crea modello",
  },
  notConnected:
    'Il tuo account non ha nessun WhatsApp Business collegato (WABA). Collegalo prima nella sezione "WhatsApp Business".',
  filters: {
    search: "Cerca",
    searchPlaceholder: "Cerca per nome...",
    status: "Stato",
    all: "Tutti",
    category: "Categoria",
    allFem: "Tutte",
    language: "Lingua",
    refresh: "Aggiorna",
  },
  list: {
    loading: "Caricamento modelli...",
    emptyTitle: "Nessun modello",
    emptyText: "Prova a modificare i filtri o crea il tuo primo modello.",
    baseBadge: "Base",
    edit: "Modifica",
    duplicate: "Duplica",
    deleteProtected: "Modello base: non può essere eliminato",
    delete: "Elimina",
    prev: "← Precedente",
    next: "Successivo →",
  },
  preview: {
    noText: "(nessun testo)",
    noContent: "Nessun contenuto",
  },
  time: {
    now: "Adesso",
    minutesAbbr: "{n} min",
    hoursAbbr: "{n}h",
  },
  common: {
    close: "Chiudi",
    cancel: "Annulla",
  },
  editor: {
    createTitle: "Crea modello",
    editTitle: "Modifica modello",
    sectionBasic: "Base",
    name: "Nome (snake_case)",
    nameHintHtml:
      "Gli spazi diventano <code>_</code>. Solo <code>a-z</code>, <code>0-9</code> e <code>_</code>.",
    language: "Lingua",
    category: "Categoria",
    sectionHeader: "Intestazione",
    enable: "Attiva",
    type: "Tipo",
    headerLocationHintHtml:
      "L'intestazione LOCATION non contiene testo o esempi nel modello. La posizione (lat/lng + nome/indirizzo) viene inviata al momento della consegna del messaggio tramite <code>/messages</code>.",
    headerMediaHint:
      "Se utilizzi MEDIA, il tuo account potrebbe richiedere esempi/handle durante la revisione.",
    headerTextLabel: "Testo (max 60)",
    headerTextPlaceholder: "Es. Ciao {{1}}, la tua prenotazione è pronta.",
    insert: "Inserisci",
    autoExample: "Esempio automatico",
    examplesHeader: "Esempi (intestazione)",
    remove: "Rimuovi",
    headerLocationNote: "All'inizio del messaggio verrà inviata una scheda con mappa.",
    headerMediaNote: "Questa intestazione verrà mostrata come allegato (media).",
    sectionBody: "Corpo",
    bodyPlaceholder: "Scrivi il contenuto. Usa {{1}}, {{2}}...",
    examplesBody: "Esempi (corpo)",
    sectionFooter: "Piè di pagina",
    footerPlaceholder: "Testo breve (opzionale, max 60)",
    sectionButtons: "Pulsanti",
    addButton: "+ Aggiungi",
    noButtons: "Nessun pulsante (opzionale).",
    buttonTextPlaceholder: "Testo del pulsante (max 25)",
    removeButton: "Elimina",
    previewTitle: "Anteprima",
    viewPayload: "Visualizza il payload inviato a Meta",
    metaDebug: "Risposta / errore di Meta (debug)",
    validReady: "Pronto per il salvataggio.",
    validIncomplete: "Completa i campi obbligatori prima di salvare.",
    saving: "Salvataggio...",
    save: "Salva",
  },
  delete: {
    title: "Elimina modello",
    irreversible: "Questa azione non può essere annullata.",
    willDeletePre: "Il modello ",
    willDeletePost: " verrà eliminato.",
    confirmLabel: "Digita il nome esatto per confermare:",
    confirmPlaceholder: "Digita il nome esattamente",
    confirmHint: "Il pulsante si attiva quando il testo corrisponde esattamente.",
    deleting: "Eliminazione...",
    confirmDelete: "Elimina definitivamente",
  },
  errors: {
    nameRequired: "Il nome è obbligatorio.",
    nameInvalid: "Formato non valido. Usa solo a-z, 0-9 e _.",
    headerRequired: "Il testo dell'intestazione è obbligatorio se l'intestazione è attiva.",
    headerMax: "Il testo dell'intestazione può contenere al massimo 60 caratteri.",
    bodyRequired: "Il corpo è obbligatorio.",
    bodyMax: "Il corpo può contenere al massimo 1024 caratteri.",
    footerMax: "Il piè di pagina può contenere al massimo 60 caratteri.",
    buttonTextRequired: "Il testo del pulsante è obbligatorio.",
    buttonTextMax: "Massimo 25 caratteri.",
    phoneInvalid: "PHONE_NUMBER deve essere in formato E.164 (es. +34123456789).",
    urlInvalid: "L'URL deve iniziare con http:// o https://",
    loadDetail: "Impossibile caricare i dettagli del modello.",
    save: "Errore durante il salvataggio del modello.",
    deleteFailed: "Impossibile eliminare il modello.",
  },
  duplicate: {
    defaultBody: "Copia del modello. Modifica il contenuto. Grazie {{1}}.",
  },
};
